import * as types from './types'
import storage from '@/plugins/storage'
export default {
  [types.RESET_LOGIN](state) {
    state.roles = null
    state.token = null
    state.username = null
    storage.session.clear()
  },
  [types.SET_TOKEN](state, token) {
    state.token = token
    storage.session.setItem(types.SESSION_TOKEN_NAME, token)
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
    var tokenPayload = JSON.parse(jsonPayload)
    state.profile = {
      user: parseInt(tokenPayload.uid),
      contact: parseInt(tokenPayload.cid),
      firm: parseInt(tokenPayload.fid),
      timezone: parseInt(tokenPayload.tz),
      firstName: tokenPayload.fname,
      lastName: tokenPayload.lname,
      username: tokenPayload.uname,
      email: tokenPayload.email,
      language: tokenPayload.cc,
      roles: []
    }
    for (let i = 0; i < tokenPayload.rid.length; i++) {
      state.profile.roles.push(parseInt(tokenPayload.rid[i]))
    }
    storage.session.setItem(
      types.SESSION_USER_PROFILE,
      JSON.stringify(state.profile)
    )
  },
  [types.SET_PASSTHROUGH](state, passthrough) {
    state.passthrough = passthrough
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js